import React from 'react'
import {BreadcrumbsItem} from 'wix-ui-tpa/dist/cssVars/types/components'
import {Breadcrumbs as TPABreadcrumbs} from 'wix-ui-tpa/cssVars'

import {useGetLayoutSize} from '../LayoutSizeProvider'
import {BreadcrumbsAlignment, Alignment} from '../../types/createStylesParams'

import {classes, st} from './styles.st.css'

interface BreadcrumbsProps {
  items: BreadcrumbsItem[]
  className?: string
  // TODO: BreadcrumbsAlignment deprecated, migrate to Alignment
  alignment?: BreadcrumbsAlignment | Alignment
}

export const Breadcrumbs = ({items, className, alignment = Alignment.Left}: BreadcrumbsProps) => {
  const {layoutSize} = useGetLayoutSize()

  const alignmentClass = BreadcrumbsAlignmentToClass[alignment]

  return (
    <TPABreadcrumbs
      className={st('', {[layoutSize]: true}, className, alignmentClass, classes.root)}
      items={items}
      showTrailOnMobileMode
    />
  )
}

export const BreadcrumbsAlignmentToClass: Record<Exclude<Alignment, Alignment.Stretch>, string> = {
  [Alignment.Left]: classes.left,
  [Alignment.Center]: classes.center,
  [Alignment.Right]: classes.right,
}
